import { Component } from '@angular/core';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})

export class PageComponent {
  skipToContent(event: Event,id:string): void {
    event.preventDefault(); // Prevents navigation
    const mainContent = document.getElementById(id);
    if (mainContent) {
      mainContent.focus();
    }
  }
}
